import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../Auth/types";
import { Task } from "./slice";
import { ErrorEditTask, ErrorsCreateNewTask } from "../../Types/Types";
import { api } from "../../utils/api";
import { isAxiosError } from "axios";

export const getAllTasks = createAsyncThunk(
    'tasks/getAllTask',
    async (_, thunkAPI) => {
      try {
        const state = thunkAPI.getState() as RootState;
        const persistedToken = state.auth.token;
        const res = await api.get("/web-request/getAllTasks", {
            headers: { 
              Authorization: `Bearer ${persistedToken}`,
            },
        })
          if (!persistedToken) return thunkAPI.rejectWithValue('Token missing');
      
          return res.data.tasksUser.allTasks;
        } catch (error: unknown) {
            const message =
                error instanceof Error
                ? error.message
                : 'Something went wrong';
        
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const addNewTask = createAsyncThunk(
  'tasks/AddTask',
  async (credentials: ErrorsCreateNewTask, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const persistedToken = state.auth.token;

      if (!persistedToken) {
        return thunkAPI.rejectWithValue('Token missing');
      }

      const res = await api.post("/web-request/addTask", credentials, {
        headers: {
          Authorization: `Bearer ${persistedToken}`,
          'Content-Type': 'application/json'
        }
      });

      console.log(res.data)

      return res.data.taskData.task;
    } catch (error) {

      if (isAxiosError(error)) {
      console.log("Full error:", error.response?.data?.errors);
        const serverErrors = error.response?.data?.errors;
        if (serverErrors && typeof serverErrors === 'object') {
            return thunkAPI.rejectWithValue(serverErrors);
        }
      
      }
      return thunkAPI.rejectWithValue({ general: "Unknown error" });
    }
  }
);

export const editTaskUser = createAsyncThunk<
  Task,
  { id: string; credentials: ErrorEditTask },
  { state: RootState }
>(
  'tasks/EditTask',
  async ({ id, credentials }, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const persistedToken = state.auth.token;

      if (!persistedToken) {
        return thunkAPI.rejectWithValue('Token missing');
      }

      const res = await api.put(
        `/web-request/updateTask/${id}`,
        credentials,
        {
          headers: {
            Authorization: `Bearer ${persistedToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      // ✅ Повертаємо лише розшифровану задачу
      return res.data;
    } catch (error) {
      if (isAxiosError(error)) {
        console.log("Full error:", error.response?.data);
        const serverErrors = error.response?.data;
        if (serverErrors && typeof serverErrors === 'object') {
          return thunkAPI.rejectWithValue(serverErrors);
        }

        if (!error.name) {
          return thunkAPI.rejectWithValue({ general: error.name });
        }
      }
      return thunkAPI.rejectWithValue({ general: "Unknown error" });
    }
  }
);


export const deleteUserTask = createAsyncThunk<
  { deletedTask: Task; message: string },
  string,
  { state: RootState; rejectValue: string }  // thunkAPI типи
>(
  "tasks/deleteUserTask",
  async (id, thunkAPI) => {
    try {
      const state = thunkAPI.getState() as RootState;
      const persistedToken = state.auth.token;

      if (!persistedToken) {
        return thunkAPI.rejectWithValue('Token missing');
      }

      const res = await api.delete(`/web-request/deleteTask/${id}`, {
        headers: {
          Authorization: `Bearer ${persistedToken}`,
          'Content-Type': 'application/json'
        },
      })
      
      return {
            deletedTask: res.data.DeleteTaskMessage.deletedTask,
            message: res.data.DeleteTaskMessage.message
        };
    } catch (error) {
      const message =
        error instanceof Error ? error.message : "Something went wrong";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const DeleteAllTaskUser = createAsyncThunk<
  { deletedTask: Task; message: string },
  { userId: string },
  { state: RootState; rejectValue: string }
  >("tasks/DeleteAllTaskUser",
    async (userId, thunkAPI) => {
      try {
        const state = thunkAPI.getState() as RootState;
        const persistedToken = state.auth.token;

        if (!persistedToken) {
        return thunkAPI.rejectWithValue('Token missing');
      }

      const res = await api.delete(`/web-request/deleteAllTasks/${userId}`, {
        headers: {
          Authorization: `Bearer ${persistedToken}`,
          'Content-Type': 'application/json'
        },
      })
        
        return res.data
      } catch (error) {
        const message =
        error instanceof Error ? error.message : "Something went wrong";
      return thunkAPI.rejectWithValue(message);
      }
    }
)

